/**
 * Formata valores decimais de horas
 * @param {number|null|undefined} hours - Horas em decimal
 * @param {number} decimals - Número de casas decimais (padrão: 2)
 * @param {string} fallback - Valor a retornar se inválido (padrão: '-')
 * @returns {string} Horas formatadas ou fallback
 */
export function formatDecimalHours(hours, decimals = 2, fallback = '-') {
  if (hours === null || hours === undefined || isNaN(hours)) {
    return fallback;
  }
  return hours.toFixed(decimals);
}

/**
 * Formata valores decimais de dias
 * @param {number|null|undefined} days - Dias em decimal
 * @param {number} decimals - Número de casas decimais (padrão: 4)
 * @param {string} fallback - Valor a retornar se inválido (padrão: '-')
 * @returns {string} Dias formatados ou fallback
 */
export function formatDecimalDays(days, decimals = 4, fallback = '-') {
  if (days === null || days === undefined || isNaN(days)) {
    return fallback;
  }
  return days.toFixed(decimals);
}

/**
 * Retorna a classe CSS baseada no tempo de lead time
 * @param {number|null|undefined} hours - Horas em decimal
 * @returns {string} Classe CSS (tx-success, tx-warning, tx-danger ou tx-gray-600)
 */
export function getLeadTimeTextClass(hours, invert = false) {
  if (hours === null || hours === undefined || isNaN(hours)) {
    return 'tx-gray-600';
  }
  
  // Thresholds: verde < 1h, amarelo < 24h, vermelho >= 24h
  if (hours < 1) {
    return invert ? 'tx-danger' : 'tx-success';
  } else if (hours < 24) {
    return 'tx-warning';
  } else {
    return invert ? 'tx-success' : 'tx-danger';
  }
}

/**
 * Formata lead time completo (horas e dias)
 * @param {number|null|undefined} hours - Horas em decimal
 * @param {number|null|undefined} days - Dias em decimal
 * @param {string} fallback - Valor a retornar se inválido (padrão: '-')
 * @returns {string} Lead time formatado
 */
export function formatLeadTime(hours, days, fallback = '-') {
  if (hours === null || hours === undefined) {
    return fallback;
  }
  
  const hoursInt = Math.floor(hours);
  const daysInt = Math.floor(days || 0);
  
  if (daysInt > 0) {
    return `${daysInt} dia(s) e ${hoursInt % 24} hora(s)`;
  }
  return `${hoursInt} hora(s)`;
}

